<template>
  <view @click.stop="() => {}">
    <uv-overlay
      :z-index="toastStore.isVisible ? 10989 : -9990"
      :opacity="0"
      :show="toastStore.isVisible"
      @click.stop="handleOverlayClick"
    />
    <view
      class="c-toast c-taost__main--loading"
      :class="toastStore.isVisible ? 'open' : 'close'"
      :style="computeStyle"
      @click.stop="() => {}"
    >
      <image
        v-if="toastStore.type === 'loading'"
        class="c-toast__loading-svg"
        src="/static/common/tail-spin.svg"
      />
      <view class="c-taost__text">{{ toastStore.message }}</view>
    </view>
  </view>
</template>

<script setup lang="ts">
import { useToastStore } from '@/store/useToastStore';
import { computed } from 'vue';

// Toast 组件状态
const toastStore = useToastStore();

const computeStyle = computed(() => {
  if (toastStore.type !== 'loading') {
    return {
      padding: '20rpx',
      'border-radius': '16rpx',
    };
  }
  return {};
});

const handleOverlayClick = () => {};
</script>

<style scoped lang="scss">
.c-toast {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: auto;
  height: auto;
  min-width: 264rpx;
  max-width: 532rpx;
  padding: 20rpx;
  border-radius: 20rpx;
  background: #4c4c4c;

  &.c-taost__main--loading {
    min-width: 204rpx;
    padding: 14rpx 14rpx 28rpx;
  }

  &.open {
    z-index: 10991;
    opacity: 1;
    transition: opacity 100ms linear;
  }

  &.close {
    z-index: -9991;
    opacity: 0;
    transition: opacity 100ms linear, z-index 0ms linear 100ms;
  }

  .c-toast__loading-svg {
    width: 72rpx;
    height: 72rpx;
    margin: 28rpx 0;
  }

  .c-taost__text {
    text-align: center;
    color: rgba(255, 255, 255, 0.9);
    font-size: 26rpx;
  }
}
</style>
